export const GET_USER_TO_BILL_LIST = "GET_USER_TO_BILL_LIST";
export const USER_TO_BILL_LIST = "USER_TO_BILL_LIST";

export const SAVE_USER_TO_BILL = "SAVE_USER_TO_BILL";
export const SAVE_USER_TO_BILL_RESP = "SAVE_USER_TO_BILL_RESP";

export const DELETE_USER_TO_BILL = "DELETE_USER_TO_BILL";
export const DELETE_USER_TO_BILL_RESP = "DELETE_USER_TO_BILL_RESP";
